import React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import { Copy } from "lucide-react";
import { toast } from "@components/ui/use-toast";
import InfoTooltip from "@components/common/InfoTooltip";

type props = {
  selectedKey: string | null;
  handleSelectVariablesOption: (value: string) => void;
  mappedRequestIds: string[] | null;

  inputName: string;
  setInputName: (value: string) => void;
  isAuthVar: boolean;
  setIsAuthVar: (value: boolean) => void;
  isLogMapping: boolean;
  handleAddVariableMapping: () => void;
  handleSetMappingData: (logicBlockId: string | null) => void;
  selectedOption: string | null;
  mapRefInput: React.RefObject<HTMLInputElement>;
  selectedLogicBlockId: string | null;
  setSelectedKey: (value: string | null) => void;
  setShowKeyDialog: (value: boolean) => void;
  selectedLogicName: string | null | undefined;
  requestId: number | undefined;
};

const ResponseActionsDialog: React.FC<props> = ({
  selectedKey,
  handleSelectVariablesOption,
  mappedRequestIds,

  inputName,
  setInputName,
  isAuthVar,
  setIsAuthVar,
  isLogMapping,
  handleAddVariableMapping,
  handleSetMappingData,
  selectedOption,
  mapRefInput,
  selectedLogicBlockId,
  setSelectedKey,
  setShowKeyDialog,
  selectedLogicName,
  requestId,
}) => {
  const copyPathToClipboard = () => {
    navigator.clipboard.writeText(String(selectedKey));
    toast({
      variant: "info",
      title: "Copied!",
      description: "Path copied to clipboard.",
      duration: 2000,
    });
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-background border-2 p-4 rounded-md shadow-lg w-96">
        <div className="flex items-center justify-between gap-2 border-b pb-2 mb-2">
          <h2 className="font-bold w-[85%] truncate">
            Map Key : <span className="text-primary">{selectedKey}</span>
          </h2>
          <button
            onClick={copyPathToClipboard}
            className="flex justify-end whitespace-nowrap gap-1 text-muted-foreground hover:text-primary transition"
            aria-label="Copy response"
          >
            <Copy size={16} /> <span>Copy path</span>
          </button>
        </div>

        {/* if common variable is selected, show input field  */}

        <Select
          defaultValue="none"
          onValueChange={(value) => handleSelectVariablesOption(value)}
        >
          <SelectTrigger className="w-full mb-1 mt-1">
            <SelectValue placeholder="Select type of action" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectItem value="none">Save as local variable</SelectItem>
              <SelectItem value="common">Save as Common variable</SelectItem>
              {selectedLogicName === "Save Logs" && (
                <SelectItem
                  value="saveLogs"
                  disabled={mappedRequestIds?.includes(String(requestId))}
                >
                  Save to Log Mapping
                  {mappedRequestIds?.includes(String(requestId)) &&
                    " (Already mapped)"}
                </SelectItem>
              )}
              {selectedLogicName === "Data List" && (
                <SelectItem
                  value="saveDataList"
                  // disabled={hasMappedDataList}
                >
                  {" "}
                  Save to DataList{" "}
                  {/* {hasMappedDataList &&
                    "(Already mapped)"} */}
                </SelectItem>
              )}
            </SelectGroup>
          </SelectContent>
        </Select>

        {(selectedOption == "common" || selectedOption == "none") && (
          <>
            <input
              type="text"
              className="w-full p-2 border bg-transparent rounded-md mb-2 mt-2 focus:ring-secondary focus:ring-1"
              placeholder="Enter name (e.g. access_token)"
              value={inputName}
              onChange={(e) =>
                setInputName(e.target.value.replace(/\s+/g, "_"))
              }
              ref={mapRefInput}
            />

            <div className="mt-2 mb-2 flex items-center">
              <input
                type="checkbox"
                checked={isAuthVar}
                onChange={(e) => setIsAuthVar(e.target.checked)}
                id="isAuthVar"
                className="h-4 w-4"
              />
              <label
                htmlFor="isAuthVar"
                className="ml-2 text-sm text-muted-foreground mr-2"
              >
                {" "}
                Is Authentication Variable ?
              </label>
              <InfoTooltip text="Authentication variables are used to refresh and replace dynamic values, such as access tokens." />
            </div>
          </>
        )}

        <div className="flex justify-end gap-2 mt-3">
          <button
            className="px-4 py-2 border rounded-md text-sm"
            onClick={() => {
              setShowKeyDialog(false);
              setInputName("");
              setSelectedKey(null);
            }}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 bg-primary text-white rounded-md text-sm ${!isLogMapping && !inputName.trim() ? "opacity-50 cursor-not-allowed" : ""}`}
            onClick={
              isLogMapping
                ? () => handleSetMappingData(selectedLogicBlockId ?? null)
                : handleAddVariableMapping
            }
            disabled={!isLogMapping && !inputName.trim()}
          >
            {isLogMapping ? "Map fields" : "Add to variables"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResponseActionsDialog;
